export const TEXT_NOT_ALLOWED_FIRST_ROUND_BUILDINGS = 'В первом раунде нельзя строить Дороги и Центральные кварталы!';
export const TEXT_MINE_EXPLORATION_NOT_PLANNABLE = 'Рудники нельзя планировать: разведка рудника проводится только в свой ход';
export const TEXT_NO_ACTIONS_REMAINING = 'У вас не осталось действий для строительства!'
export const TEXT_CANNOT_REPAIR_WHEN_ADJACENT_ENEMY_UNIT = 'Нельзя починить строение, когда смежно находится вражеский отряд'
export const TEXT_TURN_ALREADY_ENDED = 'Ваш ход уже завершен'

// Автоматическое завершение хода при планировании строительства
export const TEXT_AUTO_COMPLETE_TURN_BUTTON = 'Автоматически\nзавершить ход'
export const TEXT_PLANNED_BUILDINGS_INVALID = 'Запланированные строения размещены некорректно:'
export const TEXT_AUTO_COMPLETE_TURN_DISABLED = 'Автоматическое завершение хода отключено'
export const TEXT_AUTO_COMPLETE_TURN_NOT_DONE = 'Ход не завершен автоматически'

// Двойной клик по запланированному, без которого не встало бы запланированное позже
export const buildTextPlanUndoConflict = (laterLabel) => (
  `Нельзя снять с плана: без этого строения нельзя было бы построить запланированное позже${laterLabel ? ` — «${laterLabel}»` : ''}.\nСначала снимите его.`
)

